import React from "react";
import {useSelector} from "react-redux";
import {useHistory, useLocation} from "react-router";
import {css} from "@panda/css";

import {Pagination, PaginationSize} from "@pg-design/pagination-module";
import {Tabs} from "@pg-design/tabs";
import {Text} from "@pg-design/text-module";
import {appendQueryString, parseSearch, validateQuery} from "@pg-mono/request";
import {useUserDevice} from "@pg-mono/user-device";

import {IRPStore} from "../../../app/rp_reducer";
import {ARTICLE_LIST_PAGE_SIZE} from "../../actions/fetch_article_list";
import {articleListBoxTitle, ArticleListBoxWide} from "../../components/article_list/ArticleListBoxWide";

const getMaxPageCount = (count: number, sortValue: "all" | "rating") => {
    if (count === 0) {
        return 1;
    }

    if (sortValue === "rating") {
        return 1;
    }

    return Math.ceil(count / ARTICLE_LIST_PAGE_SIZE);
};

const MAX_TOP_RATED_ARTICLES = 10;

export const AuthorArticlesListing = (props: {className?: string}) => {
    const {isMobile} = useUserDevice();

    const authorName = useSelector((state: IRPStore) => state.article.authorDetail.author?.name);
    const articles = useSelector((state: IRPStore) => state.article.authorDetail.articles);

    const history = useHistory();
    const location = useLocation();
    const count = useSelector((state: IRPStore) => state.article.authorDetail.articlesCount);

    const query = parseSearch(location.search);
    const currentPage = typeof query.page === "string" ? parseInt(query.page, 10) : 1;
    const sortValue = query.sort === "rating" ? "rating" : "all";
    const displayedArticles =
        !!articles && sortValue === "rating" && articles.length > MAX_TOP_RATED_ARTICLES ? articles.slice(0, MAX_TOP_RATED_ARTICLES) : articles;

    const maxPage = getMaxPageCount(count ?? 0, sortValue);

    const getPageLink = (page: number) => {
        const query = validateQuery(["page"], parseSearch(location.search), page >= 2 ? {page: page.toString()} : {});
        return appendQueryString(location.pathname, query);
    };

    const sortHandler = (sortOption: string) => {
        const newQuery = new URLSearchParams(history.location.search);
        if (newQuery.has("sort")) {
            newQuery.set("sort", sortOption);
            newQuery.delete("page");
        } else {
            newQuery.append("sort", sortOption);
        }

        const newLocation = `${location.pathname}?${newQuery}`;
        history.push(newLocation);
    };

    return (
        <section className={props.className}>
            <Text className={headingStyle} as="h2" variant="headline_2">
                Artykuły napisane przez {authorName}
            </Text>

            <Tabs
                className={listingSort}
                activeColor="gray"
                fullWidth
                onChange={sortHandler}
                color="gray"
                value={sortValue}
                tabs={[
                    {title: "Wszystkie", value: "all"},
                    {title: "Najlepiej oceniane", value: "rating"}
                ]}
                variant="contained"
            />

            {!!displayedArticles && (
                <>
                    <div className={articlesWrapper}>
                        {displayedArticles.map((article) => (
                            <ArticleListBoxWide
                                articleTitle={
                                    <Text className={articleListBoxTitle} as="h3" variant="headline_4">
                                        {article.header}
                                    </Text>
                                }
                                className={listItem}
                                article={article}
                                key={article.id}
                            />
                        ))}
                    </div>

                    <div className={paginationWrapper}>
                        <Pagination
                            getPageLink={getPageLink}
                            pageCount={maxPage}
                            currentPage={currentPage}
                            size={isMobile ? PaginationSize.MD : PaginationSize.LG}
                            siblingsCount={isMobile ? 0 : 1}
                        />
                    </div>
                </>
            )}
        </section>
    );
};

const headingStyle = css({
    mb: 4,
    md: {
        mb: 5
    }
});

const listingSort = css({
    mb: 4,
    maxWidth: "44rem"
});

const articlesWrapper = css({
    pb: 4
});

const listItem = css({
    "&:not(:last-of-type)": {
        mb: 2
    }
});

const paginationWrapper = css({
    mb: 8
});
import React from "react";
import {useSelector} from "react-redux";
import {useHistory, useLocation} from "react-router";
import {css} from "@panda/css";

import {Pagination, PaginationSize} from "@pg-design/pagination-module";
import {Tabs} from "@pg-design/tabs";
import {Text} from "@pg-design/text-module";
import {appendQueryString, parseSearch, validateQuery} from "@pg-mono/request";
import {useUserDevice} from "@pg-mono/user-device";

import {IRPStore} from "../../../app/rp_reducer";
import {ARTICLE_LIST_PAGE_SIZE} from "../../actions/fetch_article_list";
import {articleListBoxTitle, ArticleListBoxWide} from "../../components/article_list/ArticleListBoxWide";

const getMaxPageCount = (count: number, sortValue: "all" | "rating") => {
    if (count === 0) {
        return 1;
    }

    if (sortValue === "rating") {
        return 1;
    }

    return Math.ceil(count / ARTICLE_LIST_PAGE_SIZE);
};

const MAX_TOP_RATED_ARTICLES = 10;

export const AuthorArticlesListing = (props: {className?: string}) => {
    const {isMobile} = useUserDevice();

    const authorName = useSelector((state: IRPStore) => state.article.authorDetail.author?.name);
    const articles = useSelector((state: IRPStore) => state.article.authorDetail.articles);

    const history = useHistory();
    const location = useLocation();
    const count = useSelector((state: IRPStore) => state.article.authorDetail.articlesCount);

    const query = parseSearch(location.search);
    const currentPage = typeof query.page === "string" ? parseInt(query.page, 10) : 1;
    const sortValue = query.sort === "rating" ? "rating" : "all";
    const displayedArticles =
        !!articles && sortValue === "rating" && articles.length > MAX_TOP_RATED_ARTICLES ? articles.slice(0, MAX_TOP_RATED_ARTICLES) : articles;

    const maxPage = getMaxPageCount(count ?? 0, sortValue);

    const getPageLink = (page: number) => {
        const query = validateQuery(["page"], parseSearch(location.search), page >= 2 ? {page: page.toString()} : {});
        return appendQueryString(location.pathname, query);
    };

    const sortHandler = (sortOption: string) => {
        const newQuery = new URLSearchParams(history.location.search);
        if (newQuery.has("sort")) {
            newQuery.set("sort", sortOption);
            newQuery.delete("page");
        } else {
            newQuery.append("sort", sortOption);
        }

        const newLocation = `${location.pathname}?${newQuery}`;
        history.push(newLocation);
    };

    return (
        <section className={props.className}>
            <Text className={headingStyle} as="h2" variant="headline_2">
                Artykuły napisane przez {authorName}
            </Text>

            <Tabs
                className={listingSort}
                activeColor="gray"
                fullWidth
                onChange={sortHandler}
                color="gray"
                value={sortValue}
                tabs={[
                    {title: "Wszystkie", value: "all"},
                    {title: "Najlepiej oceniane", value: "rating"}
                ]}
                variant="contained"
            />

            {!!displayedArticles && (
                <>
                    <div className={articlesWrapper}>
                        {displayedArticles.map((article) => (
                            <ArticleListBoxWide
                                articleTitle={
                                    <Text className={articleListBoxTitle} as="h3" variant="headline_4">
                                        {article.header}
                                    </Text>
                                }
                                className={listItem}
                                article={article}
                                key={article.id}
                            />
                        ))}
                    </div>

                    <div className={paginationWrapper}>
                        <Pagination
                            getPageLink={getPageLink}
                            pageCount={maxPage}
                            currentPage={currentPage}
                            size={isMobile ? PaginationSize.MD : PaginationSize.LG}
                            siblingsCount={isMobile ? 0 : 1}
                        />
                    </div>
                </>
            )}
        </section>
    );
};

const headingStyle = css({
    mb: 4,
    md: {
        mb: 5
    }
});

const listingSort = css({
    mb: 4,
    maxWidth: "44rem"
});

const articlesWrapper = css({
    pb: 4
});

const listItem = css({
    "&:not(:last-of-type)": {
        mb: 2
    }
});

const paginationWrapper = css({
    mb: 8
});
